import { useDispatch, useSelector } from "react-redux"
import { selectShipmentsKind, setShipmentsKind, shipmentKinds } from "../../shipmentsSlice"
import { useTranslation } from "react-i18next"

const SendedFilter = () => {
    const {t}  = useTranslation()
    const dispatch = useDispatch()
    const selectedKind = useSelector(selectShipmentsKind)

    const selectKind = (kind) => {
        dispatch(setShipmentsKind({kind}))
    }

  return (
    <div className="flex">
        <div className="border cursor-pointer px-2 py-1 font-light text-2xs sm:text-base"
            style={{
                background: selectedKind === shipmentKinds.all ? "#059669" : "white",
                color: selectedKind  === shipmentKinds.all ? "white" : "" 
            }}
            onClick={() => selectKind(shipmentKinds.all)}>
            {t("shipments.shipments_list.filter.all")}
        </div>

        <div className="border cursor-pointer px-2 py-1 font-light text-2xs sm:text-base"
            style={{
                background: selectedKind  === shipmentKinds.sent ? "#059669" : "white" ,
                color: selectedKind  === shipmentKinds.sent ? "white" : "" 
            }}
            onClick={() => selectKind(shipmentKinds.sent)}>
            {t("shipments.shipments_list.filter.sended")}
        </div>

        <div className="border cursor-pointer px-2 py-1 font-light text-2xs sm:text-base"
            style={{
                background: selectedKind  === shipmentKinds.not_sent ? "#059669" : "white", 
                color: selectedKind  === shipmentKinds.not_sent ? "white" : "" 
            }}
            onClick={() => selectKind(shipmentKinds.not_sent)}>
            {t("shipments.shipments_list.filter.not_sended")}
        </div>
    </div>
  )
}

export default SendedFilter